import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CITATION_STYLES } from "@/lib/api";

export default function CitationStyleSelector({ value, onChange, compact = false }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger
        data-testid="citation-style-selector"
        className={`${compact ? "h-8 text-xs w-[110px]" : "h-10 w-[130px]"} bg-white dark:bg-[#3B2350] border-[#F5D0E3] dark:border-[#45325A]`}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {CITATION_STYLES.map((s) => (
          <SelectItem key={s.id} value={s.id} data-testid={`citation-style-option-${s.id}`}>
            {s.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
